import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faInboxIn} from '@fortawesome/pro-solid-svg-icons';
import {CartCurrentUploadEvent} from './constants';
import {canUploadCurrentCart} from '../enablers';
import {CurrentCartActionLabel} from '../locales';

export const uploadCartCurrentUploadActionIcon = faInboxIn;

/**
 * Bulk loader
 * @param params
 * @returns Action
 */
export const uploadCartCurrentUploadAction = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'upload-bulk-cart-loader',
	cb: () => dispatcher.trigger(CartCurrentUploadEvent.UPLOAD),
	enableTest: () => canUploadCurrentCart(),
	icon: uploadCartCurrentUploadActionIcon,
	get label() {
		return CurrentCartActionLabel.ROUTE;
	},
	...params,
});

export default uploadCartCurrentUploadAction;
